import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../Redux/Actions/SnackbarActions/SnackbarActions";
import PharmacySnackbar from "../../../Utils/Snackbars/SnackbarUtil";
import { PLContainer } from "../../../Utils/styledComponents";
import { CustomCell } from "../../../Utils/AccountingUtils/CoaList";
import { usePrint } from "../../../Utils/Templates/usePrint";
import { BackButton } from "../../../Utils/Buttons/DataExportationButton";
import { PrintPdfButtons } from "./PrintPdfButtons";
import companyAddress from "../../../Helpers/companyAddress.json";
import Card from "@material-ui/core/Card";
import { reverseDate, formatDate, convertDate } from "../../../Utils/ConvertDate";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ReusableDashboardHeader from "../../../Containers/Dasboard/ReusableDashboardHeader";
import { history } from "../../../Helpers/history";
import { useQuery } from "react-query";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { useCompany } from "../../../Context/company-context";
import { LoadingGif } from "../../../Utils/Loader";
import { NoTransaction } from "../COA/ReusableJournalTable";
import { formatAmount } from "../../../Utils/formatAmount";


const useStyles = makeStyles({
  totalCell: {
    padding: "8px 8px 8px 0",
    textTransform: "uppercase",
    fontWeight: "bold",
    borderBottom: "3px double black",
  },
  amountCell: {
    borderBottom: "3px double black",
    width: "100px",
    paddingBottom: 0,
    textAlign: "right",
  },
});

const TrialBalance = ({ actions, snackbars }) => {
  const classes = useStyles();
  const { state } = useCompany();
  const { logo } = state;

  const [dates, setDates] = useState({
    startDate: reverseDate(convertDate()),
    endDate: reverseDate(convertDate()),
  });

  const { isLoading, isError, isSuccess, data } = useQuery(
    ["trialBalanceQuery", dates],
    async () => {
      try {
        const response = await axios.get(
          `${config.epharmUrl}/accounting/new_trail_balance_report`,
          {
            params: {
              start_date: dates.startDate,
              end_date: dates.endDate,
            },
          }
        );
        const resData = response?.data;
        return {
          categories: resData?.categories ?? {},
          totalCredits: resData?.total_credits ?? 0,
          totalDebits: resData?.total_debits ?? 0,
        };
      } catch (error) {
        return { categories: {}, totalCredits: 0, totalDebits: 0 };
      }
    },
    { retry: 1 }
  );

  const { open, variant, message } = snackbars;
  const { componentRef, handlePrint } = usePrint("TrailBalance");
  const { img_url: image } = companyAddress;

  const handleChangeDate = (event) => {
    setDates({ ...dates, [event.target.name]: event.target.value });
  };

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Trial Balance"
        heading="Accounting"
        subHeading="Trial Balance"
        link={history.location.pathname}
      />

      <PharmacySnackbar message={message} open={open} variant={variant} />

      <div className="d-flex justify-content-start align-items-center ml-4 mt-3">
        <BackButton to="/allreports" text="Reports" />
      </div>

      <PLContainer>
        {isLoading && (
          <div className="text-center mt-5">
            <LoadingGif />
          </div>
        )}

        {isSuccess ? (
          <Card className="mx-2 my-3">
            <div
              style={{ padding: "8px 16px", borderBottom: "1px solid rgba(224,224,224,1)" }}
              className="d-flex justify-content-between align-items-center"
            >
              <div className="d-flex">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="startDate">From&nbsp;</label>
                  <input
                    type="date"
                    name="startDate"
                    value={dates.startDate}
                    onChange={handleChangeDate}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group d-flex align-items-center ml-4">
                  <label htmlFor="endDate">To&nbsp;</label>
                  <input
                    type="date"
                    name="endDate"
                    value={dates.endDate}
                    onChange={handleChangeDate}
                    className="form-control"
                    required
                  />
                </div>
              </div>

              <div>
                <PrintPdfButtons downloadPdf={() => {}} handlePrint={handlePrint} />
              </div>
            </div>

            <div className="p-3">
              <div ref={componentRef}>
                <table className="table table-sm table-borderless prescription-table">
                  <tbody>
                    <tr>
                      <td align="center">
                        <img
                          className="img-fluid img-thumbnail border-0 w-25 h-25"
                          src={logo ?? image}
                          alt="smartmedlogo"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <h5><strong>Trial Balance</strong></h5>
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <h6><strong>{formatDate(new Date())}</strong></h6>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>&nbsp;</TableCell>
                      <TableCell className={classes.amountCell}><strong>CREDITS</strong></TableCell>
                      <TableCell className={classes.amountCell}><strong>DEBITS</strong></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>

                <Table>
                  <TableBody>
                    {data?.categories && Object.entries(data.categories).length > 0 ? (
                      Object.entries(data.categories).map(([key, values], idx) => (
                        <React.Fragment key={idx}>
                          <TableRow>
                            <TableCell colSpan={3} style={{ fontWeight: "bold", paddingTop: "1rem" }}>
                              {key}
                            </TableCell>
                          </TableRow>

                          {values?.account_details && values.account_details.length > 0 ? (
                            values.account_details.map((acc, index) => (
                              <TableRow key={index}>
                                <TableCell>{acc.account}</TableCell>
                                <TableCell className={classes.amountCell}>{formatAmount(acc.credit)}</TableCell>
                                <TableCell className={classes.amountCell}>{formatAmount(acc.debit)}</TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} align="center">No Data Available</TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <TableRow>
                        <CustomCell align="center" colSpan={3}>
                          <strong>No Data available</strong>
                        </CustomCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.totalCell}><strong>Total</strong></TableCell>
                      <TableCell className={classes.amountCell}>{formatAmount(data?.totalCredits ?? 0)}</TableCell>
                      <TableCell className={classes.amountCell}>{formatAmount(data?.totalDebits ?? 0)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </div>
          </Card>
        ) : (
          <NoTransaction text="transactions" />
        )}

        {isError && <div>The server did not return a valid response</div>}
      </PLContainer>
    </div>
  );
};

const mapStateToProps = (state) => ({ snackbars: state.snackbars });

const mapDispatchToProps = (dispatch) => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) },
});

export default connect(mapStateToProps, mapDispatchToProps)(TrialBalance);
